import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AddCircle from '@mui/icons-material/AddCircle';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DateTime } from 'luxon';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { createSearchParams, useSearchParams, useNavigate } from 'react-router-dom';
import { objectToQueryString, baseUrl, apiHelper } from 'helpers/util';

import ColumnBox from 'components/ColumnBox';
import CardList from 'components/CardList';
import CardItem from 'components/CardItem';
import SmallestHeading from 'components/SmallestHeading';
import SmallHeading from 'components/SmallHeading';
import BigHeading from 'components/BigHeading';

export default function Form() {
    const navigate = useNavigate();
    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ prevTrainings, setPrevTrainings ] = useState([]);
    const [ employeeSessions, setEmployeeSessions ] = useState([]);
    const [ userInfo, setUserInfo ] = useState({});
    const [ topics, setTopics ] = useState([]);

    const loadEmployeeReport = function(userName) {
        const apiParams = { "user_name": userName, "route": "folk_training.employee_report" }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_custom_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) {
                for (const t of response.json.message.sessions) {
                    t.session_date = t.session_date ?
                        DateTime.fromISO(t.session_date).toFormat('dd-MMM-yyyy')
                        : t.session_date
                }
                setEmployeeSessions(response.json.message.sessions);
                setTopics(response.json.message.topics);
                if (response.json.message.user && response.json.message.user.length > 0) {
                    setUserInfo(response.json.message.user[0]);
                }
            }
            else { console.log(response.json); }
        })
    }

    useEffect(function() {
        if (searchParams.get('user_name')) {
            loadEmployeeReport(searchParams.get('user_name'));
        }
    }, [])

    return (
        <Box sx={{ padding: '15px' }}>
            <SmallHeading>{userInfo.full_name}</SmallHeading>
            <SmallestHeading>{userInfo.name}</SmallestHeading>
            <SmallHeading>Topics</SmallHeading>
            <Box sx={{ display: 'flex', maxWidth: '500px', width: '100%', flexWrap: 'wrap' }}>
                { topics.map(t => (
                    <FormControlLabel key={t.topic} control={
                        <Checkbox disabled
                            name={t.topic} checked={t.status == 'attended'} />
                    } label={t.topic} />
                )) }
            </Box>
            <SmallHeading>Sessions Attended</SmallHeading>
            <CardList>
                { employeeSessions.map(p => (
                    <CardItem sx={{ 'cursor': 'pointer' }}>
                        <SmallestHeading>{p.taken_by}</SmallestHeading>
                        <Box>{p.session_date}</Box>
                    </CardItem>
                )) }
            </CardList>
        </Box>
    );
}
